import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Login from './Login';
import Chat from './Chat';
import NotFound from './NotFound';
import ProtectedRoute from './ProtectedRoute';
import UpdateToast from './UpdateToast';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="app-container">
          <UpdateToast />
          <Routes>
            <Route path="/:id/:channel" element={<Login />} />
            <Route
              path="/chat/:id/:channel"
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
